// Enhanced mock data with CRM entities
export const MOCK_PRODUCTS = [
  {
    id: 'prod-001',
    name: 'Standard Door Handle',
    type: 'handle',
    price: 45.00,
    compatibleDoorTypes: ['standard', 'fire-rated'],
    description: 'Basic lever handle for interior doors'
  },
  {
    id: 'prod-002',
    name: 'Premium Door Handle',
    type: 'handle',
    price: 89.00,
    compatibleDoorTypes: ['standard', 'exit', 'fire-rated'],
    description: 'High-grade lever handle with brushed finish'
  },
  {
    id: 'prod-003',
    name: 'Exit Push Bar',
    type: 'handle',
    price: 165.00,
    compatibleDoorTypes: ['exit'],
    description: 'Panic exit push bar for emergency doors'
  },
  {
    id: 'prod-004',
    name: 'Standard Hinge Set',
    type: 'hinge',
    price: 28.00,
    compatibleDoorTypes: ['standard'],
    description: '3-piece hinge set for standard doors'
  },
  {
    id: 'prod-005',
    name: 'Heavy Duty Hinge Set',
    type: 'hinge',
    price: 52.00,
    compatibleDoorTypes: ['exit', 'fire-rated'],
    description: '4-piece heavy duty hinge set'
  },
  {
    id: 'prod-006',
    name: 'Basic Lock System',
    type: 'lock',
    price: 75.00,
    compatibleDoorTypes: ['standard'],
    description: 'Standard mortise lock with key'
  },
  {
    id: 'prod-007',
    name: 'Electronic Lock System',
    type: 'lock',
    price: 285.00,
    compatibleDoorTypes: ['standard', 'exit'],
    description: 'Keycard access electronic lock'
  },
  {
    id: 'prod-008',
    name: 'Fire-Rated Lock System',
    type: 'lock',
    price: 195.00,
    compatibleDoorTypes: ['fire-rated'],
    description: 'UL-listed fire-rated mortise lock'
  },
  {
    id: 'prod-009',
    name: 'Door Closer',
    type: 'closer',
    price: 68.00,
    compatibleDoorTypes: ['standard', 'exit', 'fire-rated'],
    description: 'Hydraulic door closer for controlled closing'
  },
  {
    id: 'prod-010',
    name: 'Fire Door Closer',
    type: 'closer',
    price: 125.00,
    compatibleDoorTypes: ['fire-rated'],
    description: 'Fire-rated automatic door closer'
  },
  {
    id: 'prod-011',
    name: 'Door Stop',
    type: 'accessory',
    price: 12.00,
    compatibleDoorTypes: ['standard'],
    description: 'Floor-mounted door stop'
  },
  {
    id: 'prod-012',
    name: 'Kick Plate',
    type: 'accessory',
    price: 35.00,
    compatibleDoorTypes: ['standard', 'exit', 'fire-rated'],
    description: 'Stainless steel kick plate'
  }
];

// Door type definitions
export const DOOR_TYPES = [
  { id: 'standard', name: 'Standard', description: 'Interior standard door' },
  { id: 'exit', name: 'Exit', description: 'Emergency exit door' },
  { id: 'fire-rated', name: 'Fire-Rated', description: 'Fire-rated door with compliance requirements' }
];

// Auto-assign hardware rules by door type
export const AUTO_ASSIGN_RULES = {
  'standard': ['prod-001', 'prod-004', 'prod-006', 'prod-011'],
  'exit': ['prod-003', 'prod-005', 'prod-007', 'prod-009', 'prod-012'],
  'fire-rated': ['prod-002', 'prod-005', 'prod-008', 'prod-010', 'prod-012']
};

// Builder statuses
export const BUILDER_STATUSES = [
  { id: 'tendering', name: 'Tendering', color: 'slate' },
  { id: 'likely', name: 'Likely', color: 'blue' },
  { id: 'won', name: 'Won', color: 'green' },
  { id: 'lost', name: 'Lost', color: 'red' }
];

// Builder types
export const BUILDER_TYPES = [
  'Large Commercial Builder',
  'Medium Commercial Builder',
  'Small Commercial Builder',
  'Residential Builder',
  'Luxury Residential Builder',
  'Mixed Use Builder',
  'Government / Public Works',
  'Subcontractor',
  'Developer',
  'Other',
];

// Builder customer status
export const BUILDER_CUSTOMER_STATUSES = [
  { id: 'existing', name: 'Existing Customer' },
  { id: 'new_lead', name: 'New Lead' },
];

// Builder account statuses
export const BUILDER_ACCOUNT_STATUSES = [
  { id: 'good', name: 'Good Standing' },
  { id: 'on_hold', name: 'On Hold' },
  { id: 'overdue', name: 'Overdue' },
  { id: 'inactive', name: 'Inactive' },
];

// Opportunity statuses
export const OPPORTUNITY_STATUSES = [
  { id: 'qualification', name: 'Qualification', color: 'slate' },
  { id: 'proposal', name: 'Proposal', color: 'blue' },
  { id: 'negotiation', name: 'Negotiation', color: 'amber' },
  { id: 'won', name: 'Won', color: 'green' },
  { id: 'lost', name: 'Lost', color: 'red' }
];

// Industry options (fixed list)
export const INDUSTRY_OPTIONS = [
  'Commercial',
  'Healthcare',
  'Education',
  'Government',
  'Hospitality',
  'Residential',
  'Retail',
  'Industrial',
  'Infrastructure',
  'Mixed Use'
];

// Project type options (fixed list, multi-select)
export const PROJECT_TYPE_OPTIONS = [
  'door hardware',
  'sanitary',
  'locksmith install',
  'doors',
  'electronic security'
];

// Opportunity phases (project lifecycle, separate from CRM pipeline status)
export const OPPORTUNITY_PHASES = [
  { id: 'lead',     name: 'Lead' },
  { id: 'tender',   name: 'Tender' },
  { id: 'awarded',  name: 'Awarded' },
  { id: 'design',   name: 'Design' },
  { id: 'supply',   name: 'Supply' },
  { id: 'complete', name: 'Complete' },
];

// Quote statuses
export const QUOTE_STATUSES = [
  { id: 'draft', name: 'Draft', color: 'slate' },
  { id: 'submitted', name: 'Submitted', color: 'blue' },
  { id: 'active', name: 'Active Schedule', color: 'green' }
];

// ERP workflow stages
export const ERP_STAGES = [
  { id: 'allocated', name: 'Inventory Allocated', icon: 'Package' },
  { id: 'picking', name: 'Picking', icon: 'ClipboardList' },
  { id: 'packing', name: 'Packing', icon: 'Box' },
  { id: 'shipped', name: 'Shipped', icon: 'Truck' },
  { id: 'invoiced', name: 'Invoiced', icon: 'FileText' }
];

// Generate a unique ID
export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Create a builder contact
export const createContact = (data) => ({
  id: data.id || generateId(),
  name: data.name || '',
  email: data.email || '',
  phone: data.phone || '',
  role: data.role || ''
});

// Create a new opportunity
export const createOpportunity = (data) => ({
  id: generateId(),
  name: data.name || 'Untitled Opportunity',
  developer: data.developer || '',
  notes: data.notes || '',
  industry: data.industry || '',
  projectDescription: data.projectDescription || '',
  tenderLinkId: data.tenderLinkId || '',
  projectTypes: Array.isArray(data.projectTypes) ? data.projectTypes : [],
  status: data.status || 'qualification',
  phase: data.phase || '',
  estimatedValue: data.estimatedValue || 0,
  closeDate: data.closeDate || null,
  jobChaseDate: data.jobChaseDate || null,
  jobChaseNotes: data.jobChaseNotes || '',
  expectedProjectStart: data.expectedProjectStart || null,
  expectedProjectFinish: data.expectedProjectFinish || null,
  expectedSupplyStart: data.expectedSupplyStart || null,
  createdAt: new Date().toISOString(),
  builders: []
});

// Create a new builder
export const createBuilder = (data) => {
  const contacts = Array.isArray(data.contacts) ? data.contacts : [];
  const fallbackContact = (data.contact || data.email || data.phone)
    ? [createContact({ name: data.contact, email: data.email, phone: data.phone })]
    : [];
  const normalizedContacts = contacts.length > 0
    ? contacts.map(contact => createContact(contact))
    : fallbackContact;
  const primaryContact = normalizedContacts[0] || null;

  return {
    id: generateId(),
    opportunityId: data.opportunityId,
    name: data.name || 'Untitled Builder',
    // Legacy fields kept for backward compatibility and compact displays.
    contact: data.contact || primaryContact?.name || '',
    email: data.email || primaryContact?.email || '',
    phone: data.phone || primaryContact?.phone || '',
    contacts: normalizedContacts,
    status: 'tendering',
    // Extended profile fields
    address: data.address || '',
    builderType: data.builderType || '',
    customerStatus: data.customerStatus || '',
    accountStatus: data.accountStatus || '',
    creditLimit: data.creditLimit || '',
    quoteId: null,
    activities: [],
    createdAt: new Date().toISOString()
  };
};

// Create an activity
export const createActivity = (data) => ({
  id: generateId(),
  type: data.type || 'note', // note, call, meeting, email
  content: data.content || '',
  createdAt: new Date().toISOString()
});

// Create a quote (linked to builder and opportunity)
export const createQuote = (data) => ({
  id: generateId(),
  opportunityId: data.opportunityId,
  builderId: data.builderId,
  name: data.name || 'Untitled Quote',
  version: data.version || 1,
  isActive: data.isActive !== undefined ? data.isActive : true, // First quote is active by default
  status: 'draft',
  buildings: data.buildings || [],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
});

// Deep clone buildings for quote duplication
export const cloneBuildings = (buildings) => {
  return buildings.map(building => ({
    ...building,
    id: generateId(),
    floors: building.floors.map(floor => ({
      ...floor,
      id: generateId(),
      doors: floor.doors.map(door => ({
        ...door,
        id: generateId(),
        products: [...door.products]
      }))
    }))
  }));
};

// Calculate quote totals
export const calculateQuoteTotals = (quote) => {
  let totalItems = 0;
  let totalCost = 0;
  let doorCount = 0;

  if (!quote?.buildings) return { totalItems, totalCost, doorCount };

  quote.buildings.forEach(building => {
    building.floors.forEach(floor => {
      doorCount += floor.doors.length;
      floor.doors.forEach(door => {
        door.products.forEach(productId => {
          const product = MOCK_PRODUCTS.find(p => p.id === productId);
          if (product) {
            totalItems++;
            totalCost += product.price;
          }
        });
      });
    });
  });

  return { totalItems, totalCost, doorCount };
};

// Create building
export const createBuilding = (name) => ({
  id: generateId(),
  name: name || 'New Building',
  floors: []
});

// Create floor
export const createFloor = (name) => ({
  id: generateId(),
  name: name || 'New Floor',
  doors: []
});

// Create door
export const createDoor = (name, type = 'standard') => ({
  id: generateId(),
  name: name || 'New Door',
  type: type,
  notes: '',
  products: [],
  attributes: { width: 800, height: 2100 }
});

// Create multiple doors
export const createMultipleDoors = (prefix, count, type = 'standard') => {
  return Array.from({ length: count }, (_, i) => 
    createDoor(`${prefix}-${String(i + 1).padStart(3, '0')}`, type)
  );
};

// Parse a floor range string (e.g. "1-10") or comma-separated names.
export const parseFloorRange = (input) => {
  const trimmed = (input || '').trim();
  const rangeMatch = trimmed.match(/^(\d+)\s*-\s*(\d+)$/);
  if (rangeMatch) {
    const from = parseInt(rangeMatch[1], 10);
    const to = parseInt(rangeMatch[2], 10);
    if (to >= from) {
      return Array.from({ length: to - from + 1 }, (_, i) => String(from + i));
    }
  }
  return trimmed.split(',').map(s => s.trim()).filter(Boolean);
};

// Create a delivery
export const createDelivery = (data) => ({
  id: generateId(),
  quoteId: data.quoteId,
  items: data.items || [],
  status: 'allocated',
  erpStages: {
    allocated: { completed: true, date: new Date().toISOString() },
    picking: { completed: false, date: null },
    packing: { completed: false, date: null },
    shipped: { completed: false, date: null },
    invoiced: { completed: false, date: null }
  },
  totalItems: data.totalItems || 0,
  totalCost: data.totalCost || 0,
  createdAt: new Date().toISOString()
});

// Sample data generators
export const createSampleOpportunity = () => {
  return createOpportunity({
    name: 'Rialto Tower Development',
    developer: 'Urban Development Corp',
    notes: 'Major mixed-use development in downtown. 25 floors, commercial and residential.',
    industry: 'Mixed Use',
    projectDescription: '25-floor mixed-use development requiring staged specification and supply.',
    tenderLinkId: 'TDR-RIALTO-2026-01',
    projectTypes: ['door hardware', 'doors', 'electronic security'],
    estimatedValue: 450000,
    status: 'proposal',
    phase: 'tender',
    jobChaseDate: '2026-05-15',
    jobChaseNotes: 'Follow up with John Smith after council approval expected mid-May.',
    expectedProjectStart: '2026-07-01',
    expectedProjectFinish: '2027-03-31',
    expectedSupplyStart: '2026-09-01',
  });
};

export const createSampleBuilders = (opportunityId) => {
  const builders = [
    {
      ...createBuilder({ opportunityId, name: 'Brookfield Construction' }),
      contact: 'John Smith',
      email: 'john.smith@brookfield.com',
      phone: '+1 555-0101',
      contacts: [
        createContact({ name: 'John Smith', email: 'john.smith@brookfield.com', phone: '+1 555-0101', role: 'Tender Manager' }),
        createContact({ name: 'Lisa Raymond', email: 'l.raymond@brookfield.com', phone: '+1 555-0151', role: 'Project Coordinator' })
      ],
      status: 'likely',
      activities: [
        createActivity({ type: 'meeting', content: 'Initial tender meeting - discussed scope and timeline' }),
        createActivity({ type: 'email', content: 'Sent preliminary quote for review' })
      ]
    },
    {
      ...createBuilder({ opportunityId, name: 'Turner Building Co' }),
      contact: 'Sarah Johnson',
      email: 's.johnson@turner.com',
      phone: '+1 555-0102',
      contacts: [
        createContact({ name: 'Sarah Johnson', email: 's.johnson@turner.com', phone: '+1 555-0102', role: 'Estimating Lead' })
      ],
      status: 'tendering',
      activities: [
        createActivity({ type: 'call', content: 'Follow-up call on tender documents' })
      ]
    },
    {
      ...createBuilder({ opportunityId, name: 'Lendlease Projects' }),
      contact: 'Michael Chen',
      email: 'm.chen@lendlease.com',
      phone: '+1 555-0103',
      contacts: [
        createContact({ name: 'Michael Chen', email: 'm.chen@lendlease.com', phone: '+1 555-0103', role: 'Commercial Manager' })
      ],
      status: 'tendering',
      activities: []
    }
  ];
  
  return builders;
};

export const createSampleQuote = (opportunityId, builderId) => {
  const quote = createQuote({
    opportunityId,
    builderId,
    name: 'Rialto Tower - Door Schedule'
  });
  
  quote.buildings = [
    {
      id: generateId(),
      name: 'Tower A',
      floors: [
        {
          id: generateId(),
          name: 'Ground Floor',
          doors: [
            { id: generateId(), name: 'GF-001', type: 'exit', products: [], attributes: { width: 900, height: 2100 } },
            { id: generateId(), name: 'GF-002', type: 'standard', products: [], attributes: { width: 800, height: 2100 } },
            { id: generateId(), name: 'GF-003', type: 'fire-rated', products: [], attributes: { width: 900, height: 2100 } }
          ]
        },
        {
          id: generateId(),
          name: 'Level 1',
          doors: [
            { id: generateId(), name: 'L1-001', type: 'standard', products: [], attributes: { width: 800, height: 2100 } },
            { id: generateId(), name: 'L1-002', type: 'standard', products: [], attributes: { width: 800, height: 2100 } },
            { id: generateId(), name: 'L1-003', type: 'exit', products: [], attributes: { width: 900, height: 2100 } }
          ]
        }
      ]
    }
  ];
  
  return quote;
};
